export enum EventBusKeys {
    new = "new",
    batchCopyProperty = "batchCopyProperty",
    batchSetProperty = 'batchSetProperty'
}